/**
 * LayerBar - Always-visible layer selector toolbar
 * Rendered above panel content in MainLayout sidebar.
 * Provides layer switching, add, and remove across all tabs.
 */

import { useConfigStore } from '@/store/configStore';

export function LayerBar() {
  const layers = useConfigStore((state) => state.layers);
  const activeLayer = useConfigStore((state) => state.activeLayer);
  const setActiveLayer = useConfigStore((state) => state.setActiveLayer);
  const addLayer = useConfigStore((state) => state.addLayer);
  const removeLayer = useConfigStore((state) => state.removeLayer);

  const currentLayer = layers.find((l) => l.id === activeLayer);
  const canRemove = currentLayer && !currentLayer.default;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '8px 0',
        borderBottom: '1px solid #dee2e6',
        fontSize: '12px',
      }}
    >
      <span style={{ fontWeight: 600, color: '#495057', whiteSpace: 'nowrap' }}>
        Layer:
      </span>
      <select
        value={activeLayer}
        onChange={(e) => setActiveLayer(parseInt(e.target.value, 10))}
        style={{
          flex: 1,
          padding: '4px 6px',
          fontSize: '12px',
          border: '1px solid #dee2e6',
          borderRadius: '4px',
          backgroundColor: '#fff',
          minWidth: 0,
        }}
      >
        {layers.map((layer) => (
          <option key={layer.id} value={layer.id}>
            {layer.name}
            {layer.default ? ' (default)' : ''}
            {layer.note_mapping ? ' *' : ''}
          </option>
        ))}
      </select>
      <button
        onClick={() => {
          const name = prompt('Enter layer name:');
          if (name) addLayer(name);
        }}
        title="Add layer"
        style={{
          padding: '3px 8px',
          fontSize: '13px',
          border: '1px solid #dee2e6',
          borderRadius: '4px',
          cursor: 'pointer',
          backgroundColor: '#fff',
          lineHeight: 1,
        }}
      >
        +
      </button>
      <button
        onClick={() => { if (canRemove) removeLayer(activeLayer); }}
        disabled={!canRemove}
        title="Remove layer"
        style={{
          padding: '3px 8px',
          fontSize: '13px',
          border: `1px solid ${canRemove ? '#dc3545' : '#dee2e6'}`,
          borderRadius: '4px',
          cursor: canRemove ? 'pointer' : 'not-allowed',
          backgroundColor: '#fff',
          color: canRemove ? '#dc3545' : '#adb5bd',
          opacity: canRemove ? 1 : 0.5,
          lineHeight: 1,
        }}
      >
        -
      </button>
    </div>
  );
}
